import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectNewbuildingBrokerOfferBookingEnabled = (state: IState) =>
  featureToggleSelector(state).newbuildingBrokerOfferBookingEnabled;
